import axios from 'axios'
import dayjs from 'dayjs'
import { logOut, setToken } from 'features/users/stores/userSlice'
import { jwtDecode } from 'jwt-decode'

let store
export const injectStore = (_store) => {
  store = _store
}

export const ROUTE_TO_LOGIN = 'ROUTE_TO_LOGIN'

function storeRouteToLogin(path = null) {
  const routeToLogin = sessionStorage.getItem(ROUTE_TO_LOGIN)
  const pathname = path || window.location.pathname
  const ignoreRoutes = ['/', '/recuperar', '/logout']
  if (!routeToLogin && !ignoreRoutes.includes(pathname))
    sessionStorage.setItem(ROUTE_TO_LOGIN, pathname + window.location.search)
}

//const BASE_URL = window.loc'PREVIOUS_ROUTE'lace(':3000', ':8000')
const BASE_URL = window.location.origin.replace(':3000', ':8000')

const axiosPE = axios.create({
  baseURL: `${BASE_URL}/api/v1`,
  headers: { 'Content-Type': 'application/json' },
})

axiosPE.interceptors.request.use(async (req) => {
  const initialPath = window.location.pathname
  const ignoreUrls = ['/token/refresh/', '/authtoken/']

  const nuevoToken = sessionStorage.getItem('nuevoToken')
  const token = nuevoToken || store?.getState()?.user?.token
  sessionStorage.removeItem('nuevoToken')

  if (ignoreUrls.includes(req.url)) {
    return req
  }

  if (token) {
    const decodedAccessToken = jwtDecode(token)
    const accessTokenExp = dayjs.unix(parseInt(decodedAccessToken?.exp ?? '0'))
    const isAccessTokenExpired = accessTokenExp.diff(dayjs()) <= 5000

    if (!isAccessTokenExpired) {
      req.headers.Authorization = `Bearer ${token}`

      // Añadir header de permiso seleccionado
      const permisoSeleccionado = sessionStorage.getItem('permisoSeleccionado')
      if (permisoSeleccionado) {
        req.headers['X-Selected-Permission-Order'] = permisoSeleccionado
      }

      return req
    }
  }

  const refreshToken = store?.getState()?.user?.refresh

  if (!token && !refreshToken) {
    storeRouteToLogin()
    return req
  }

  if (!refreshToken) {
    store?.dispatch(logOut())
    storeRouteToLogin(initialPath)
    return req
  }

  const decodedRefresh = jwtDecode(refreshToken)
  const refreshTokenExp = dayjs.unix(parseInt(decodedRefresh?.exp ?? '0'))
  const isRefreshTokenExpired = refreshTokenExp.diff(dayjs()) <= 5000

  if (!isRefreshTokenExpired) {
    try {
      const response = await axiosPE.post('/token/refresh/', { refresh: refreshToken })

      if (!response?.data?.access) {
        store?.dispatch(logOut())
        storeRouteToLogin(initialPath)
        return Promise.reject('Token invalido')
      } else {
        store?.dispatch(setToken({ token: response.data.access }))
        req.headers.Authorization = `Bearer ${response.data.access}`

        // Añadir header de permiso seleccionado
        const permisoSeleccionado = sessionStorage.getItem('permisoSeleccionado')
        if (permisoSeleccionado) {
          req.headers['X-Selected-Permission-Order'] = permisoSeleccionado
        }

        return req
      }
    } catch (error) {
      store?.dispatch(logOut())
      storeRouteToLogin(initialPath)
      return Promise.reject('Token invalido')
    }
  } else {
    store?.dispatch(logOut())
    storeRouteToLogin(initialPath)
    return Promise.reject('Token invalido')
  }
})

axiosPE.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    const detail = error?.response?.data

    if (status === 409 && detail?.redirect) {
      if (detail.redirect !== window.location.pathname) {
        window.location.href = detail.redirect
      }
    }

    return Promise.reject(error)
  },
)

export default axiosPE
